import { Box } from '@chakra-ui/react';
import {
  Button,
  type ButtonProps,
  WrappedImage,
} from '@time-line/components/common';
import { Play } from '@time-line/components/icons';
import type { SanityImage } from '@time-line/components/types';
import Image from 'next/image';

interface ProductReviewMediaThumbnailProps extends Omit<ButtonProps, 'size'> {
  image?: SanityImage | string;
  index: number;
  isVideo?: boolean;
  activeSlide?: number;
  size?: number;
  isInteractive?: boolean;
  playButtonVariant?: 'dark' | 'light';
  isActiveSlide?: boolean;
}

export function ProductReviewMediaThumbnail({
  image,
  index,
  activeSlide,
  size,
  isVideo,
  isInteractive,
  playButtonVariant = 'dark',
  isActiveSlide,
  ...props
}: ProductReviewMediaThumbnailProps) {
  const interactiveProps = isInteractive
    ? {
        transitionDuration: 'normal',
        transitionProperty: 'common',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: isActiveSlide ? 'gray.600' : 'transparent',
        _hover: {
          borderColor: isActiveSlide ? 'gray.600' : 'blackAlpha.500',
        },
      }
    : {};

  return (
    <Button
      variant="unstyled"
      display="block"
      aria-label={`Show thumbnail #${index + 1}`}
      borderRadius="base"
      fontSize={0}
      overflow="hidden"
      {...interactiveProps}
      {...props}
    >
      {isVideo && (
        <Box
          borderRadius="full"
          bgColor={playButtonVariant === 'dark' ? 'blackAlpha.500' : 'gray.50'}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="absolute"
          top="20%"
          right="20%"
          left="20%"
          bottom="20%"
          backdropFilter="blur(10px)"
        >
          <Play
            color={playButtonVariant === 'dark' ? 'white' : 'gray.600'}
            boxSize="40%"
          />
        </Box>
      )}
      {image &&
        (typeof image === 'string' ? (
          <Image
            src={image}
            alt={`thumbnail #${index + 1}`}
            width={size}
            height={size}
            style={{
              objectFit: 'cover',
              aspectRatio: '1',
            }}
          />
        ) : (
          <WrappedImage image={image} sizes={`${size}px`} />
        ))}
    </Button>
  );
}
